import './PhoneMockup.css';

function PhoneMockup({ src, alt = 'RELI app screen', tilt = '', compact = false }) {
  return (
    <img className={`phone-mockup ${tilt} ${compact ? 'phone-mockup-compact' : ''}`} src={src} alt={alt} />
  );
}

export default PhoneMockup;
